import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { MobileCTABar } from './components/MobileCTABar';
import { HomePage } from './pages/HomePage';
import { HypothekenPage } from './pages/HypothekenPage';
import { WoonbotenPage } from './pages/WoonbotenPage';
import { VerzekeringenPage } from './pages/VerzekeringenPage';
import { OverOnsPage } from './pages/OverOnsPage';
import { KostenPage } from './pages/KostenPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { KlachtenPage } from './pages/KlachtenPage';
import { idToPath, pathToId, PageId } from './utils/routes';
export function App() {
  const [currentPage, setCurrentPage] = useState<PageId>(() => pathToId(window.location.pathname));
  // Keep state in sync with browser back/forward navigation.
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPage(pathToId(window.location.pathname));
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  // Navigate by logical page id; updates the URL so deep-links, refresh and
  // back/forward all resolve to the right page.
  const navigate = useCallback((page: string) => {
    const id = page as PageId in idToPath ? page as PageId : 'home';
    const path = idToPath[id];
    if (path !== window.location.pathname) {
      window.history.pushState({}, '', path);
    }
    setCurrentPage(id);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={navigate} data-id="element-0" />;
      case 'hypotheken':
        return <HypothekenPage onNavigate={navigate} data-id="element-1" />;
      case 'woonboten':
        return <WoonbotenPage onNavigate={navigate} data-id="element-2" />;
      case 'verzekeringen':
        return <VerzekeringenPage onNavigate={navigate} data-id="element-3" />;
      case 'over-ons':
        return <OverOnsPage onNavigate={navigate} data-id="element-4" />;
      case 'kosten':
        return <KostenPage onNavigate={navigate} data-id="element-5" />;
      case 'contact':
        return <ContactPage onNavigate={navigate} data-id="element-6" />;
      case 'privacy':
        return <PrivacyPage onNavigate={navigate} data-id="element-7" />;
      case 'klachten':
        return <KlachtenPage onNavigate={navigate} data-id="element-8" />;
      default:
        return <HomePage onNavigate={navigate} data-id="element-9" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans bg-white text-navy selection:bg-gold/30" data-id="element-10">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-gold focus:text-white focus:px-4 focus:py-2 focus:rounded-brand focus:font-bold" data-id="element-11">
        Ga naar inhoud
      </a>
      <Navbar currentPage={currentPage} onNavigate={navigate} data-id="element-12" />

      <main id="main-content" className="flex-grow" data-id="element-13">
        <AnimatePresence mode="wait" data-id="element-14">
          <motion.div key={currentPage} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} transition={{
          enter: {
            duration: 0.3,
            ease: 'easeOut'
          },
          exit: {
            duration: 0.15,
            ease: 'easeIn'
          }
        }} data-id="element-15">
            {renderPage()}
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer onNavigate={navigate} data-id="element-16" />
      <MobileCTABar data-id="element-17" />
    </div>;
}